module.exports = __webpack_public_path__ + "img/common-file-text-upload.708b61bd.svg";